import React from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import { Formik, Form as FormikForm, type FormikValues, type FormikHelpers } from 'formik';
import useTranslation from 'next-translate/useTranslation';
import { toast } from 'react-toastify';
import { TextField } from '@components/Form/TextField';
import { redirectUser } from '@/utils/redirect';
import { formikSubmit } from '@/utils/formikSubmit';
import { ActivityIndicator } from '@components/ActivityIndicator/ActivityIndicator';
import { useResetPasswordMutation } from '@stores/userApi';
import { LoginLayout } from '@components/Layouts/LoginLayout';
import styles from '../login/login.module.scss';

const ForgotPassword = () => {
  const { t } = useTranslation('forgot-password');
  const [sendPasswordReset, { isLoading }] = useResetPasswordMutation();

  const handleFormSubmit = async (values: FormikValues, actions: FormikHelpers<any>) => {
    const result = await formikSubmit({
      queryFn: sendPasswordReset,
      values,
      actions,
      showSuccess: false
    });

    if (result) {
      toast.success(t('toast.email-sent') as string);
      setTimeout(() => redirectUser(), 5000);
    }
  };

  const formSchema = Yup.object().shape({
    usernameOrEmail: Yup.string().required('form-errors:required').default('')
  });

  return (
    <>
      {isLoading && <ActivityIndicator />}

      <Container className={`${styles.formContainer} d-flex align-items-center justify-content-center`}>
        <Row>
          <Col>
            <h1 className={styles.title}>{t('form.title')}</h1>
            <div className="mb-2">{t('form.info')}</div>
            <Formik
              validationSchema={formSchema}
              onSubmit={handleFormSubmit}
              initialValues={formSchema.cast({})}
              validateOnChange={true}
              validateOnBlur={true}
            >
              {() => {
                return (
                  <FormikForm className={styles.form}>
                    <Form.Group>
                      <TextField type="text" name="usernameOrEmail" label={t('form.label')} />
                    </Form.Group>
                    <Row>
                      <Col>
                        <Button variant="primary" block size={'xl' as any} type="submit">
                          {t('form.submit')}
                        </Button>
                      </Col>
                    </Row>
                  </FormikForm>
                );
              }}
            </Formik>
          </Col>
        </Row>
      </Container>
    </>
  );
};

ForgotPassword.getLayout = function getLayout(page: React.ReactNode) {
  return <LoginLayout>{page}</LoginLayout>;
};

export default ForgotPassword;
